import { render, staticRenderFns } from "./AppointmentFollowupWithAppointment.vue?vue&type=template&id=21a37341"
import script from "./AppointmentFollowupWithAppointment.vue?vue&type=script&lang=ts"
export * from "./AppointmentFollowupWithAppointment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports